import { Controller } from "@hotwired/stimulus"

// Enlarges the in-place preview card (no modal — preview stays visible).
export default class extends Controller {
  static targets = ["scale", "button"]

  connect() {
    this.zoomed = false
  }

  toggle(event) {
    event?.preventDefault()
    this.zoomed = !this.zoomed
    this.#apply()
  }

  #apply() {
    if (this.hasScaleTarget) {
      this.scaleTarget.classList.toggle("hero-card-scale-lg", !this.zoomed)
      this.scaleTarget.classList.toggle("hero-card-scale-xl", this.zoomed)
    }
    this.element.classList.toggle("cp-catalog-show--zoomed", this.zoomed)
    if (this.hasButtonTarget) {
      this.buttonTarget.textContent = this.zoomed ? "Shrink" : "Zoom"
      this.buttonTarget.setAttribute("aria-pressed", this.zoomed ? "true" : "false")
    }
  }
}
